import { render, staticRenderFns } from "./PropertyDetail.vue?vue&type=template&id=032173f8&scoped=true&"
import script from "./PropertyDetail.vue?vue&type=script&lang=js&"
export * from "./PropertyDetail.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetail.vue?vue&type=style&index=0&id=032173f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032173f8",
  null
  
)

export default component.exports